import { useSelector } from "react-redux";
import DeliveryMethodListItem from "./DeliveryMethodListItem";

const DeliveryMethodList = () => {
	const deliveryMethods = useSelector(({ vino }) => vino.deliveryMethods.list);

	if (deliveryMethods && deliveryMethods.length > 0) {
		return (
			<div className="mb-10">
				{deliveryMethods.map((deliveryMethod, index) => (
					<DeliveryMethodListItem deliveryMethod={deliveryMethod} key={index} />
				))}
			</div>
		);
	}
	return null;
};

export default DeliveryMethodList;
